export class EnaioWorkflowsConfig {
    fd = false;
}
